// src/utils/estateValidation.js
// Contrôles avant enregistrement de la carte « Pièces de l'estate » (mêmes règles que les contraintes de la base).
export const STRUCTURES = ["foundation", "association", "endowment_fund", "joint_ownership", "heirs", "other"];
export const SCOPES = ["whole_estate", "family_held", "selected_works", "to_clarify"];
export const EXCLUSIVITIES = ["exclusive", "non_exclusive", "shared", "to_clarify"];

// Retourne un code d'erreur ou null : "commission" | "dates" | null
export function estateError(v) {
  const raw = v?.commission_pct;
  if (raw !== undefined && raw !== null && String(raw).trim() !== "") {
    const n = Number(String(raw).replace(",", "."));
    if (!Number.isFinite(n) || n < 0 || n > 100) return "commission";
  }
  if (v?.representation_start && v?.representation_end && v.representation_end < v.representation_start) return "dates";
  return null;
}

// Valeurs vides → null ; commission en nombre ; listes fermées contrôlées.
export function cleanEstateValue(key, value) {
  const s = value == null ? "" : String(value).trim();
  if (s === "") return null;
  if (key === "commission_pct") return Number(s.replace(",", "."));
  if (key === "estate_structure") return STRUCTURES.includes(s) ? s : null;
  if (key === "representation_scope") return SCOPES.includes(s) ? s : null;
  if (key === "representation_exclusivity") return EXCLUSIVITIES.includes(s) ? s : null;
  return s;
}
